import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React from 'react';
import { LocalForm } from 'react-redux-form';
import Header from '../Header';
import Footer from '../Footer';

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.registration.label.name',
    description: 'Page Header Title',
    defaultMessage: 'User Registration'
  },
  headerSubTitle: {
    id: 'confirmation.html.header',
    description: 'Page Header Subtitle',
    defaultMessage: 'Confirmation'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    return status.payload.response;
  }
};

const Signupsuccess = props => {
  const { intl } = props;

  return (
    <div className="preview page">
      <Header
        title={intl.formatMessage(messages.headerTitle)}
        subtitle={intl.formatMessage(messages.headerSubTitle)}
        icon="preview"
        locale={props.locale}
      />

      <div className="main">
        <div
          className="panel"
          style={{
            width: '60%',
            padding: '40px',
            boxSizing: 'content-box',
            marginTop: '15px',
            display: 'block',
            alignContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <LocalForm onSubmit={props.onSubmit}>
            <div className="form">
              <label
                style={{
                  width: '90%',
                  fontSize: '14px',
                  textTransform: 'none',
                  lineHeight: '150%',
                  color: '#A9A9A9'
                }}
              >
                Thank you for registering with SnowPATH. ​<br />
                <br />
                To approve your account registration request, we need to verify
                the email address entered in the user registration form. ​ ​ ​
                <br />
                <br />
                An email has been sent to you to verify your email address.
                Please follow the instructions in the email to verify your email
                address.
              </label>
              <br />
              &nbsp;
              <br />
              &nbsp;
              <div className="button-container" style={{ textAlign: 'center' }}>
                <button
                  className="button"
                  styel={{ padding: 20 }}
                  onClick={() => props.clickLoginHandler()}
                >
                  <FormattedMessage id="nav.ok" defaultMessage="OK" />
                </button>
              </div>
            </div>
          </LocalForm>
        </div>
      </div>
      <Footer />
    </div>
  );
};

Signupsuccess.propTypes = {};

export default injectIntl(Signupsuccess);



// WEBPACK FOOTER //
// ./src/components/views/Signupsuccess/index.js